import DictApi from '@/api/dict';
import Field from '@/packages/field';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import style from './index.module.scss';

@Component({ name: 'CompanyNature' })
export default class CompanyNature extends Vue {
  @Prop()
  private value!: undefined | number;

  // 单位性质
  private companyNature: undefined | number | null = null;

  private errorMsg = '';

  private created() {
    if (this.value) {
      this.companyNature = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: number) {
    if (val !== this.companyNature) {
      this.companyNature = val;
    }
  }

  public onValidator(): boolean {
    if (this.companyNature === null || typeof this.companyNature === 'undefined') {
      this.errorMsg = '请选择单位性质';
      return false;
    }
    return true;
  }

  private onChangeCompanyNature(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.CompanyNature}>
        <Field
          v-model={this.companyNature}
          label="单位性质"
          sub={true}
          onChange={() => this.onChangeCompanyNature(this.companyNature)}
          type="select"
          dictApi={DictApi.getCompanyNature}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
